module.exports = __webpack_public_path__ + "static/media/web_banner.1ea50613.png";